import { Component, Input, OnInit } from '@angular/core';
import { ComplaintsService } from '../../../core/services/complaints.service';

@Component({
	selector: 'app-donut-chart',
	templateUrl: './donut-chart.component.html',
	styleUrls: ['./donut-chart.component.scss'],
})
export class DonutChartComponent implements OnInit {
	public doughnutChartLabels = [
		'Se tocar ou Mostrar',
		'Econxar/Apalpar',
		'Intimidação',
		'Perseguição',
		'Fotografia não autorizada',
		'Outros',
	];

	public doughnutChartData = [];
	public doughnutChartType = 'doughnut';
	public doghnutColors = [
		{
			backgroundColor: [
				'rgba(110, 114, 20, 1)',
				'rgba(118, 183, 172, 1)',
				'rgba(0, 148, 97, 1)',
				'rgba(129, 78, 40, 1)',
				'rgba(129, 199, 111, 1)',
			],
		},
	];

	@Input() from: string = null;
	@Input() to: string = null;

	constructor(private complaintService: ComplaintsService) {}

	ngOnInit(): void {
		this.getComplaints(this.from, this.to);
	}

	getComplaints(from?: string, to?: string): void {
		if (from != null && to != null) {
			this.complaintService
				.getComplaintsPeT('SELF_TOUCH_OR_FLASHING', from, to)
				.subscribe((complaints: any) => {
					this.doughnutChartData[0] = complaints.Count;
				});
			this.complaintService
				.getComplaintsPeT('GROPING', from, to)
				.subscribe((complaints: any) => {
					this.doughnutChartData[1] = complaints.Count;
				});
			this.complaintService
				.getComplaintsPeT('COERCION', from, to)
				.subscribe((complaints: any) => {
					this.doughnutChartData[2] = complaints.Count;
				});
			this.complaintService
				.getComplaintsPeT('STALKING', from, to)
				.subscribe((complaints: any) => {
					this.doughnutChartData[3] = complaints.Count;
				});
			this.complaintService
				.getComplaintsPeT('UNWANTED_PHOTOS', from, to)
				.subscribe((complaints: any) => {
					this.doughnutChartData[4] = complaints.Count;
				});
			this.complaintService
				.getComplaintsPeT('OTHERS', from, to)
				.subscribe((complaints: any) => {
					this.doughnutChartData[5] = complaints.Count;
				});
		} else {
			this.complaintService
				.getComplaintsType('SELF_TOUCH_OR_FLASHING')
				.subscribe((complaints: any) => {
					this.doughnutChartData[0] = complaints.Count;
				});
			this.complaintService
				.getComplaintsType('GROPING')
				.subscribe((complaints: any) => {
					this.doughnutChartData[1] = complaints.Count;
				});
			this.complaintService
				.getComplaintsType('COERCION')
				.subscribe((complaints: any) => {
					this.doughnutChartData[2] = complaints.Count;
				});
			this.complaintService
				.getComplaintsType('STALKING')
				.subscribe((complaints: any) => {
					this.doughnutChartData[3] = complaints.Count;
				});
			this.complaintService
				.getComplaintsType('UNWANTED_PHOTOS')
				.subscribe((complaints: any) => {
					this.doughnutChartData[4] = complaints.Count;
				});
			this.complaintService
				.getComplaintsType('OTHERS')
				.subscribe((complaints: any) => {
					this.doughnutChartData[5] = complaints.Count;
				});
		}
	}
}
